import { FootingIcon } from '@/components/icons/FootingIcon';
import { DesignsList } from '@/features/designs/DesignsList';

export function FootingsAnalysisIndexPage() {
  return (
    <DesignsList
      module="analysis_zapatas"
      description="Análisis estructural de zapatas — abre uno guardado o crea uno nuevo."
      icon={<FootingIcon size={24} strokeWidth={1.5} />}
    />
  );
}
